// @flow

import {
  all,
  call,
  put,
  select,
  takeEvery,
  takeLeading,
} from 'redux-saga/effects';
import { normalize } from 'normalizr';
import type {
  actionBundleSingletonType,
  endpointSingletonType,
  reduxAction,
  selectorSingletonSetType,
  typeBundleType,
} from '../dataStoreTypes';
import { selectSession } from '../reducers/session';
import { mapEntitiesToHaveSessionId } from '../utils';

export default function* genericSingletonFetcherSagas(
  selectorSet: selectorSingletonSetType<*>,
  actionBundleSingleton: actionBundleSingletonType,
  typeBundleSingleton: typeBundleType,
  endpoint: endpointSingletonType,
  schema: any,
): Generator<any, void, any> {
  const sagas = {
    *getSingletonIfNeeded() {
      const thing = yield select(selectorSet.get);
      const sessionId = yield select(selectSession.sessionId);
      const loadingStatus = yield select(selectorSet.meta);

      if (
        (!thing ||
          (thing.sessionId < sessionId && thing.deduplicationCounter === 1)) &&
        loadingStatus.status !== 1000
      ) {
        yield put(actionBundleSingleton.pending());
      }
    },
    *getSingleton() {
      const sessionId = yield select(selectSession.sessionId);

      try {
        const thing = yield call(endpoint.get);

        const { result, entities } = normalize(thing.body, schema);

        const mappedEntities = mapEntitiesToHaveSessionId(sessionId, entities);

        yield put(actionBundleSingleton.success(result, mappedEntities));
      } catch (e) {
        yield put(actionBundleSingleton.error(e.status, e.body));
      }
    },
    *setSingletonDirect(action: reduxAction) {
      const sessionId = yield select(selectSession.sessionId);

      try {
        const thing = action.apiResponse;

        const { result, entities } = normalize(thing.body, schema);

        const mappedEntities = mapEntitiesToHaveSessionId(sessionId, entities);

        yield put(actionBundleSingleton.success(result, mappedEntities));
      } catch (e) {
        // Should never reach here, but just in case...
        yield put(actionBundleSingleton.error(e.status, e.body));
      }
    },
  };

  yield all([
    takeLeading(typeBundleSingleton.IFNEEDED, sagas.getSingletonIfNeeded),
    takeEvery(typeBundleSingleton.PENDING, sagas.getSingleton),
    takeEvery(typeBundleSingleton.SHORTDIRECT, sagas.setSingletonDirect),
  ]);
}
